export default __webpack_public_path__ + "static/media/private_livingroom.6de4a40a.svg";